import AGREGAR_CATALOGO_LOCALIDAD from '@/graphql/mutations/administracion/catalogos/localidades/agregarCatalogoLocalidad.gql';
import ACTUALIZAR_CATALOGO_LOCALIDAD from '@/graphql/mutations/administracion/catalogos/localidades/actualizarCatalogoLocalidad.gql';
import REMOVER_CATALOGO_LOCALIDAD from '@/graphql/mutations/administracion/catalogos/localidades/removerCatalogoLocalidad.gql';
import OBTENER_CATALOGO_LOCALIDADES from '@/graphql/querys/administracion/catalogos/localidades/catalogoLocalidades.gql';

export default {
  apollo: {
    catalogoLocalidades: {
      query: OBTENER_CATALOGO_LOCALIDADES,
    },
  },
  methods: {
    async mixAgregarCatalogoLocalidad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_CATALOGO_LOCALIDAD,
        variables: {
          localidad: this.catalogoLocalidad,
        },
        update: (store, { data: { agregarCatalogoLocalidad } }) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_LOCALIDADES });
          data.catalogoLocalidades.push(agregarCatalogoLocalidad);
          store.writeQuery({ query: OBTENER_CATALOGO_LOCALIDADES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixActualizarCatalogoLocalidad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CATALOGO_LOCALIDAD,
        variables: {
          id: this.catalogoLocalidadEditar.id,
          localidad: this.catalogoLocalidad,
        },
        update: (store, { data: { actualizarCatalogoLocalidad } }) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_LOCALIDADES });
          const { catalogoLocalidades } = data;
          const index = catalogoLocalidades
            .findIndex(
              (catalogoLocalidad) => catalogoLocalidad.id === actualizarCatalogoLocalidad.id,
            );
          if (index !== -1) {
            catalogoLocalidades.splice(index, 1, actualizarCatalogoLocalidad);
          }
          store.writeQuery({ query: OBTENER_CATALOGO_LOCALIDADES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixRemoverCatalogoLocalidad(id) {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_LOCALIDAD,
        variables: {
          id,
        },
        update: (store) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_LOCALIDADES });
          data.catalogoLocalidades = data.catalogoLocalidades
            .filter((catalogoLocalidad) => catalogoLocalidad.id !== id);
          store.writeQuery({ query: OBTENER_CATALOGO_LOCALIDADES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
};
